<template>
  <a-modal :title="form.id ? '修改会员配置信息' : '新增会员配置信息'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleOk" @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="会员名称" prop="vip_name">
        <a-input v-model="form.vip_name" placeholder="请输入会员名称" />
      </a-form-model-item>
      <a-form-model-item ref="vip_price" label="价格" prop="vip_price">
        <a-input-number v-model="form.vip_price" :min="0" :step="0.01" style="width: 100%" placeholder="请输入会员现价" />
      </a-form-model-item>
      <a-form-model-item ref="vip_price2" label="原价" prop="vip_price2">
        <a-input-number v-model="form.vip_price2" :min="0" :step="0.01" style="width: 100%" placeholder="请输入会员现价" />
      </a-form-model-item>
      <a-form-model-item label="会员福利" prop="benefit">
        <a-textarea v-model="form.benefit" placeholder="请输入会员福利" :auto-size="{ minRows: 3, maxRows: 5 }" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        vip_id: "",
        vip_name: "",
        vip_price: null,
        vip_price2: null,
        benefit: "",
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        vip_name: [
          {
            required: true,
            message: "请输入会员名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "输入长度为1-32位",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.vip_id = id;
      if (id) {
        this.$http({
          url: "/admin/viplist/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = { ...res.data }
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
          };
          this.$http({
            url: this.form.vip_id ? "/admin/viplist/update" : "/admin/viplist/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style></style>